import BreadcrumbItem from "./BreadcrumbItem";
import Breadcrumb from "./Breadcrumb";

Breadcrumb.Item = BreadcrumbItem;

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/index.js